import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Carousel.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CarouselLoading = function CarouselLoading(_ref) {
  var item = _ref.item;
  var items = Array(4).fill();
  return /*#__PURE__*/_jsx("div", {
    className: css.carousel,
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsxs("ul", {
      className: css.items,
      children: [/*#__PURE__*/_jsx("li", {
        "aria-hidden": "true",
        className: css.ghost,
        children: "\xA0"
      }), items.map(function (_, idx) {
        return /*#__PURE__*/_jsx("li", {
          className: cc([css.itemWrap, css.loading]),
          children: item.children
        }, "carousel-item-".concat(idx));
      }), /*#__PURE__*/_jsx("li", {
        "aria-hidden": "true",
        className: css.ghost,
        children: "\xA0"
      })]
    })
  });
};

CarouselLoading.propTypes = {
  item: PropTypes.shape({
    children: PropTypes.node
  })
};
export default CarouselLoading;